import http from '@util/http';
import { hr } from '@api/req';

export async function queryWorkOrg(params) {
  return http.get(hr.HR_WORKORG_SEARCH, params);
}

export async function queryWorkOrgList(params) {
  return http.get(hr.HR_WORKORG_LIST, params);
}

export async function queryAddWorkOrg(params) {
  return http.post(hr.HR_WORKORG_SAVE, params);
}

export async function queryDeleteWorkOrg(params) {
  return http.get(hr.HR_WORKORG_DELETE, params);
}

export async function querySaveWorkOrgHr(params) {
  return http.post(hr.HR_WORKORG_HR_SAVE, params);
}

export async function queryDeleteWorkOrgHr(params) {
  return http.get(hr.HR_WORKORG_HR_DELETE, params);
}

export async function queryDeletesWorkOrgHr(params) {
  return http.get(hr.HR_WORKORG_HR_DELETES, params);
}

export async function queryHrListByWorkOrg(params) {
  return http.get(hr.HR_WORKORG_HR_LIST, params);
}



// WEBPACK FOOTER //
// ./src/api/hr/workOrg.js